import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Avatar from '@material-ui/core/Avatar'
import { Grid, Paper } from '@material-ui/core'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import { FormatQuoteRounded as FormatQuoteRoundedIcon } from '@material-ui/icons'

const useStyles = makeStyles(theme => ({
    xLarge: {
        width: theme.spacing(15),
        height: theme.spacing(15),
        [theme.breakpoints.down('sm')]: {
            width: theme.spacing(12),
            height: theme.spacing(12),
            marginBottom: '20px'
        },
    },
    m1: {
        margin: '10px 0',
    },
    boxPaper: {
        marginTop: '20px',
    },
    paper: {
        display: 'flex',
        padding: '20px',
        backgroundColor: '#525fff',
        minHeight: '235px',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column'
        },
    },
    headerAvatar: {
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.down('sm')]: {
            alignSelf: 'center'
        },
    },
    headerComment: {
        display: 'flex',
        // justifyContent: 'center',
        flexDirection: 'column',
        // marginTop: '10px'
    },
    descriptionComment: {
        fontSize: '15px',
        color: '#FFF',
        paddingBottom: '0px !important'
    },
    headerTitle: {
        color: '#FFF',
        fontWeight: 'bold',
        padding: '0px !important'
    },
    paperStyle: {
        padding: '20px',
    },
}))

export default function CardCordenation(props) {
    const classes = useStyles()
    return (
        <>
            <Grid item xs={12} sm={12} md={6} lg={6} className={classes.boxPaper}>
                <Paper className={classes.paper} elevation={3}>
                    <Grid xs={3} lg={3} component="div" className={classes.paperStyle} alignItems="center" className={classes.headerAvatar}>
                        <Avatar
                            aria-label="recipe"
                            src={props.image}
                            className={classes.xLarge} />
                    </Grid>
                    <Grid xs={9} lg={9} component="div" className={classes.paperStyle} alignItems="center" className={classes.headerComment}>
                        <CardHeader
                            className={classes.headerTitle}
                            title={props.title}
                        />
                        <CardContent component="div" className={classes.descriptionComment}>
                            {props.description}
                        </CardContent>
                    </Grid>
                </Paper>
            </Grid>
        </>
    )
}
